import {
  ColumnLayout,
  Input,
  Box,
  FormField,
  SpaceBetween,
  Form,
  Container,
  Button,
} from "@cloudscape-design/components-themed";
import { LABELS } from "./constants";
import { COMMON_LABELS } from "../default-constants";

/*===================================================================================
 * 料率調整案件の法人情報入力フォーム
 * 概要：法人情報入力フォームを実装
 *
 * 前の画面からの必要なパラメーター
 * なし
 *
 * 遷移先：なし
 * 戻り先：なし
 ===================================================================================*/
//未実装：法人番号検索による入力フォームの活性化制御
const InputForm = (props: any) => {
  return (
    <SpaceBetween direction="vertical" size="l">
      <Form>
        <SpaceBetween direction="vertical" size="l">
          <Container>
            {props.isRegister ? (
              <SpaceBetween direction="vertical" size="l">
                <FormField
                  label={
                    <SpaceBetween direction="horizontal" size="xs">
                      <Box variant="strong">{LABELS.CORP_NUMBER}</Box>
                      <Box variant="small" color="text-status-error">
                        {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                      </Box>
                    </SpaceBetween>
                  }
                  stretch={true}
                  errorText={props.corporateNumberErrorMsg}
                  constraintText="半角数字13桁"
                >
                  <SpaceBetween direction="horizontal" size="l">
                    <Input
                      value={props.corporateNumber}
                      onChange={(e) => {
                        props.setCorporateNumber(e.detail.value);
                        props.setIsFormEntered(true);
                        props.setIsRegistrationButton(true);
                        props.checkCorporateNumber(
                          e.detail.value,
                          props.setCorporateNumberErrorMsg,
                          false
                        );
                      }}
                    />
                    <Button
                      formAction="none"
                      variant="normal"
                      onClick={props.onClickCorporateNumberSearch}
                    >
                      {COMMON_LABELS.BTNS.SEARCH_CORP_NUM}
                    </Button>
                  </SpaceBetween>
                </FormField>
                <ColumnLayout columns={4}>
                  <FormField
                    label={
                      <SpaceBetween direction="horizontal" size="xs">
                        <Box variant="strong">{LABELS.CORP_NAME}</Box>
                        <Box variant="small" color="text-status-error">
                          {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                        </Box>
                      </SpaceBetween>
                    }
                    stretch={true}
                    errorText={props.companyNameErrorMsg}
                  >
                    <Input
                      value={props.companyName}
                      disabled={!props.isInputEditable}
                      readOnly={true}
                      onChange={(e) => {
                        props.setCompanyName(e.detail.value);
                        props.setIsFormEntered(true);
                        props.checkNull(
                          e.detail.value,
                          props.setCompanyNameErrorMsg
                        );
                      }}
                    />
                  </FormField>
                  <FormField
                    label={
                      <SpaceBetween direction="horizontal" size="xs">
                        <Box variant="strong">{LABELS.CORP_KANA}</Box>
                      </SpaceBetween>
                    }
                    stretch={true}
                    errorText={props.companyNameKanaErrorMsg}
                  >
                    <Input
                      value={props.companyNameKana}
                      disabled={!props.isInputEditable}
                      readOnly={true}
                      onChange={(e) => {
                        props.setCompanyNameKana(e.detail.value);
                        props.setIsFormEntered(true);
                      }}
                    />
                  </FormField>
                </ColumnLayout>
                <ColumnLayout columns={2}>
                  <FormField
                    label={
                      <SpaceBetween direction="horizontal" size="xs">
                        <Box variant="strong">{LABELS.ADDRESS}</Box>
                        <Box variant="small" color="text-status-error">
                          {COMMON_LABELS.INPUT_ITEM_MESSAGE.REQUIRED}
                        </Box>
                      </SpaceBetween>
                    }
                    stretch={true}
                    errorText={props.addressErrorMsg}
                  >
                    <Input
                      value={props.address}
                      disabled={!props.isInputEditable}
                      readOnly={true}
                      onChange={(e) => {
                        props.setAddress(e.detail.value);
                        props.setIsFormEntered(true);
                        props.checkNull(
                          e.detail.value,
                          props.setAddressErrorMsg
                        );
                      }}
                    />
                  </FormField>
                </ColumnLayout>
              </SpaceBetween>
            ) : (
              <SpaceBetween direction="vertical" size="l">
                <FormField
                  label={
                    <SpaceBetween direction="horizontal" size="xs">
                      <Box variant="strong">{LABELS.CORP_NUMBER}</Box>
                    </SpaceBetween>
                  }
                  stretch={true}
                >
                  <SpaceBetween direction="horizontal" size="l">
                    <Input value={props.corporateNumber} readOnly />
                  </SpaceBetween>
                </FormField>
                <ColumnLayout columns={4}>
                  <FormField
                    label={
                      <SpaceBetween direction="horizontal" size="xs">
                        <Box variant="strong">{LABELS.CORP_NAME}</Box>
                      </SpaceBetween>
                    }
                    stretch={true}
                  >
                    <Input value={props.companyName} readOnly={true} />
                  </FormField>
                  <FormField
                    label={
                      <SpaceBetween direction="horizontal" size="xs">
                        <Box variant="strong">{LABELS.CORP_KANA}</Box>
                      </SpaceBetween>
                    }
                    stretch={true}
                  >
                    <Input value={props.companyNameKana} readOnly={true} />
                  </FormField>
                </ColumnLayout>
                <ColumnLayout columns={2}>
                  <FormField
                    label={
                      <SpaceBetween direction="horizontal" size="xs">
                        <Box variant="strong">{LABELS.ADDRESS}</Box>
                      </SpaceBetween>
                    }
                    stretch={true}
                  >
                    <Input value={props.address} readOnly={true} />
                  </FormField>
                </ColumnLayout>
              </SpaceBetween>
            )}
          </Container>
        </SpaceBetween>
      </Form>
    </SpaceBetween>
  );
};
export default InputForm;
